
<template>
  <div class="modalback">
    <div class="modalcontent row justify-content-center">
      <div class="close cursor-pointer"><img src="@/assets/acrypro/close.svg" @click="closeAction"/></div>
      <p class="fw-bold" style="font-size: 28px;">一覧プレビュー</p>

      <div style="width:100px; height:50px;"></div>

      <div class="row m-0" style="width:700px;">
          <div class="col-auto row p-0 my-auto" @click="prevPage" style="cursor: pointer">
              <div class="col-auto p-0 pagination-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                  <path d="M19.8155 9.2625L18.0365 7.5L10.4661 15L18.0365 22.5L19.8155 20.7375L14.0368 15L19.8155 9.2625Z" fill="#8C9BC6"/>
                </svg>
              </div>
              <div class="col-auto px-1 my-auto pagination-text-select">前へ</div>
          </div>

          <div class="col p-0 m-auto pagination-text" v-for="(n, index) in this.getLoopNumList" :key="index">
            <span v-bind:class="{ 'pagination-text-select': currentPageNum == n }" @click="clickPage(n)">{{n}}</span>
          </div>

          <div class="col-auto row p-0 my-auto" @click="nextPage" style="cursor: pointer">
              <div class="col-auto px-1 my-auto pagination-text-select">次へ</div>
              <div class="col-auto p-0 pagination-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                  <path d="M12.9634 7.5L11.1843 9.2625L16.9631 15L11.1843 20.7375L12.9634 22.5L20.5338 15L12.9634 7.5Z" fill="#8C9BC6"/>
                </svg>
              </div>
          </div>
      </div>

      <div class="row mx-5 my-1" style="width:330px;">
        <!-- <div class="col row">
          <form class="col p-0 jump-border" style="width:40px;" onsubmit="return false;">
            <input
              type="text"
              class="w-100 h-100 px-2"
              style="border:0px;"
              id="text"
              v-model="jumpPageNum"
            />
          </form>
          <div class="col-auto p-0 jump-border" @click="jumpPage" style="cursor: pointer; width:30px; border-left-width:0px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
              <path d="M12.9634 7.5L11.1843 9.2625L16.9631 15L11.1843 20.7375L12.9634 22.5L20.5338 15L12.9634 7.5Z" fill="#595959"/>
            </svg>
          </div>
        </div> -->

        <div class="col-7 m-auto px-1" style="font-size:15px;">
          {{ editedNum }}/{{ quantity }} 編集済み
        </div>
      </div>

      <!-- <img class="imageViewer m-auto" :src="this.$store.state.previewImageArray[0]" /> -->

      <div class="scroll d-flex flex-wrap">
        <div class="item m-1" v-for="(item, index) in this.designImageList" v-bind:key="index">
          <p v-if="editedList[index+((currentPageNum-1) * getIncrements)]" class="text-start num-text m-0">{{index+((currentPageNum-1) * getIncrements)+1}}.済み</p>
          <p v-else class="text-start num-text m-0">{{index+((currentPageNum-1) * getIncrements)+1}}</p>
          <div class="image" :style="styleVariables(index)"></div>
          <!-- <img :src="item" style="width:500px;" class=""/> -->
        </div>

      </div>

    </div>
  </div>
</template>
<script>


export default {
  name: "ImagesPreviewPopupAp",
  props: {},
  data: function () {
    return {
      designImageList:[],

      editedNum: 0,
      editedList: [],

      jumpPageNum: 1,

      isLoading: false,

      // ページネーション用
      currentPageNum: 1,  // 現在のページ番号
    };
  },
  async created() {

    if (this.$store.state.currentCanvasData) {
      this.editedList = Array.from({ length: this.quantity }, () => 1);
      // 未編集をカウントしていく
      for (const item of this.$store.state.currentCanvasData.itemList.slice()) {
        for (let i = 0; i < this.quantity; ++i) {
          if (item.textArray[i] == "") {
            this.editedList[i] = 0;
          }
        }
      }
      this.editedNum = this.editedList.filter((item) => item == 1).length;
    }

    await this.updatePreviewImage();

  },
  mounted: function () {
    // 画面の遷移があるか調べる

  },

  computed: {
    quantity() {
      return this.$store.state.currentProduct.quantity;
    },

    // ページネーション用
    // #region
    // 最大表示数
    getMaxPageView(){
      return 10;
    },

    // 総ページ数
    getMaxPageNum(){
      return Math.ceil(this.quantity/50);
    },

    // 描画をするページのテキストを返す
    getLoopNumList(){
      let textList = [];
      const maxPage = Math.min(this.getMaxPageView, this.getMaxPageNum)

      if( this.getMaxPageView >= this.getMaxPageNum ){
        for( let i=0; i<this.getMaxPageNum; ++i ){
          textList.push(i+1);
        }
        return textList;
      }

      // 先頭は1固定
      textList.push(1);
      for( let i=1; i<maxPage-1; ++i ){
        // 「…」の可能性がある場所
        if( i==1 && this.currentPageNum >= Math.ceil(maxPage / 2) + 1 ){
          textList.push('…');
          continue;
        }

        // 「…」の可能性がある場所
        if( i==maxPage-2 && this.getMaxPageNum - this.currentPageNum >= Math.floor(maxPage / 2) + 1 ){
          textList.push('…');
          continue;
        }

        if( this.currentPageNum < Math.ceil(maxPage / 2) + 1 ){
          // 序盤
          textList.push(i+1);
        } else if( this.getMaxPageNum - this.currentPageNum >= Math.floor(maxPage / 2) + 1 ){
          // 中盤
          textList.push(this.currentPageNum - Math.ceil(maxPage / 2) + 1 + i);
        }else{
          // 終盤
          textList.push(this.getMaxPageNum - maxPage + i + 1);
        }
      }

      // 最後は最大数固定
      textList.push(this.getMaxPageNum);

      return textList;
    },
    // #endregion

    getIncrements(){
      return 50;
    }
  },

  methods: {
    styleVariables(index) {
      return {
        "background-image": 'url("' + this.designImageList[index] + '"',
      };
    },
    closeAction(){
      this.$store.commit("hideImagesPreview")
    },

    async updatePreviewImage(){

      if( this.isLoading ) return;
      this.isLoading = true;
      this.$store.commit("showLoading");

      // 初期化
      this.designImageList.splice(0);

      let start = (this.currentPageNum - 1) * this.getIncrements;
      let end = Math.min( this.currentPageNum * this.getIncrements, this.quantity );

      for( let i=start; i<end; ++i ){
        let blob = await this.$store.state.currentCanvasData.createAcrylImageBlob(i);
        //this.designImageList.push(URL.createObjectURL(blob.designImage));
        this.designImageList.push(URL.createObjectURL(blob.previewImage));
      }
      this.isLoading = false;
      this.$store.commit("hideLoading");
    },

    jumpPage(){
      if(!isNaN(this.jumpPageNum)){
        if( this.isLoading ) return;
        let num = Number(this.jumpPageNum);
        if( 0 < num && num <= this.getMaxPageNum ){
          this.currentPageNum = num;
          this.updatePreviewImage();
        }
      }
    },

    // ページネーション用
    // #region
    prevPage(){
      if( this.currentPageNum != 1 ){
        if( this.isLoading ) return;
        this.currentPageNum -= 1;
        this.updatePreviewImage();
      }
    },

    nextPage(){
      if( this.currentPageNum != this.getMaxPageNum ){
        if( this.isLoading ) return;
        this.currentPageNum += 1;
        this.updatePreviewImage();
      }
    },

    clickPage(num){
      if( !isNaN(num) ){
        if( this.isLoading ) return;
        this.currentPageNum = num;
        this.updatePreviewImage();
      }
    }
    // #endregion

  },
  components: {
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.modalback {
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  position: relative;
  z-index: 201;
  width: 1270px;
  /* height: 200px; */
  padding: 40px;
  background-color: #FEFEFE;
  border-radius: 8px;
}
.close {
  position: absolute;
  width: 48px;
  right: 40px;
}
.scroll {
  overflow-y: scroll;
  width: 1190px;
  height: 600px;
}
.num-text{
  font-size: 12px;

}
.item{
  width: 272px;
  height: 462px;

  /* background-color: aquamarine; */
}
.image{
  width: 272px;
  height: 445px;
  background-repeat: round;
  background-size: cover;
  border: 1px solid;



/* background-color: red; */

}

.jump-border {
  border: 1px solid $border-sub-color;
}

// ページネーション用
// #region
.pagination-text{
  color: $text-main-color;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer
}

.pagination-text-select{
  color: $primary-main-color;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer
}

.pagination-btn{
  border: 2px solid $primary-main-color;
}
// #endregion

</style>
